export default __webpack_public_path__ + "static/media/ic-txt.29e61043.svg";